import type { InputFrame, Pose } from '../controls/types';
import type { TourSnapshot } from './types';

export function tourInput(frame: InputFrame): InputFrame {
  return { ...frame, forward: 0, right: 0, turn: 0, up: 0, boost: false, actions: [] };
}

export function tourBodyPose(camera: Pose, tour: TourSnapshot | null): Pose {
  return tour ? { ...camera, yaw: tour.bearing } : camera;
}
